/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Admin API
 * Admin panel API — operators manage agencies, seats, roles, oversight.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AgenciesControllerFindAllV1200,
  AgenciesControllerFindAllV1Params,
  AgencyViewDto,
  AssignSubscriptionDto,
  CreateAgencyDto,
  ResendRootInviteResponseDto,
  UpdateAgencyDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAgenciesControllerCreateV1Url = () => {




  return `/v1/agencies`
}

/**
 * @summary Create an agency and email its root user the activation link
 */
export const agenciesControllerCreateV1 = async (createAgencyDto: CreateAgencyDto, options?: RequestInit): Promise<AgencyViewDto> => {

  return apiRequest<AgencyViewDto>(getAgenciesControllerCreateV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAgencyDto)
  }
);}





export const getAgenciesControllerCreateV1QueryKey = (createAgencyDto?: CreateAgencyDto,) => {
    return [
    'POST', `/v1/agencies`, createAgencyDto
    ] as const;
    }


export const getAgenciesControllerCreateV1QueryOptions = <TData = Awaited<ReturnType<typeof agenciesControllerCreateV1>>, TError = unknown>(createAgencyDto: CreateAgencyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerCreateV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgenciesControllerCreateV1QueryKey(createAgencyDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof agenciesControllerCreateV1>>> = ({ signal }) => agenciesControllerCreateV1(createAgencyDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerCreateV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgenciesControllerCreateV1QueryResult = NonNullable<Awaited<ReturnType<typeof agenciesControllerCreateV1>>>
export type AgenciesControllerCreateV1QueryError = unknown


export function useAgenciesControllerCreateV1<TData = Awaited<ReturnType<typeof agenciesControllerCreateV1>>, TError = unknown>(
 createAgencyDto: CreateAgencyDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerCreateV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerCreateV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerCreateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerCreateV1<TData = Awaited<ReturnType<typeof agenciesControllerCreateV1>>, TError = unknown>(
 createAgencyDto: CreateAgencyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerCreateV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerCreateV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerCreateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerCreateV1<TData = Awaited<ReturnType<typeof agenciesControllerCreateV1>>, TError = unknown>(
 createAgencyDto: CreateAgencyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerCreateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Create an agency and email its root user the activation link
 */

export function useAgenciesControllerCreateV1<TData = Awaited<ReturnType<typeof agenciesControllerCreateV1>>, TError = unknown>(
 createAgencyDto: CreateAgencyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerCreateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgenciesControllerCreateV1QueryOptions(createAgencyDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAgenciesControllerFindAllV1Url = (params?: AgenciesControllerFindAllV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/agencies?${stringifiedParams}` : `/v1/agencies`
}

/**
 * @summary List agencies (paginated, searchable, orderable)
 */
export const agenciesControllerFindAllV1 = async (params?: AgenciesControllerFindAllV1Params, options?: RequestInit): Promise<AgenciesControllerFindAllV1200> => {

  return apiRequest<AgenciesControllerFindAllV1200>(getAgenciesControllerFindAllV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAgenciesControllerFindAllV1QueryKey = (params?: AgenciesControllerFindAllV1Params,) => {
    return [
    `/v1/agencies`, ...(params ? [params] : [])
    ] as const;
    }


export const getAgenciesControllerFindAllV1QueryOptions = <TData = Awaited<ReturnType<typeof agenciesControllerFindAllV1>>, TError = unknown>(params?: AgenciesControllerFindAllV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerFindAllV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgenciesControllerFindAllV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof agenciesControllerFindAllV1>>> = ({ signal }) => agenciesControllerFindAllV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerFindAllV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgenciesControllerFindAllV1QueryResult = NonNullable<Awaited<ReturnType<typeof agenciesControllerFindAllV1>>>
export type AgenciesControllerFindAllV1QueryError = unknown


export function useAgenciesControllerFindAllV1<TData = Awaited<ReturnType<typeof agenciesControllerFindAllV1>>, TError = unknown>(
 params: undefined |  AgenciesControllerFindAllV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerFindAllV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerFindAllV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerFindAllV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerFindAllV1<TData = Awaited<ReturnType<typeof agenciesControllerFindAllV1>>, TError = unknown>(
 params?: AgenciesControllerFindAllV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerFindAllV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerFindAllV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerFindAllV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerFindAllV1<TData = Awaited<ReturnType<typeof agenciesControllerFindAllV1>>, TError = unknown>(
 params?: AgenciesControllerFindAllV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerFindAllV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List agencies (paginated, searchable, orderable)
 */

export function useAgenciesControllerFindAllV1<TData = Awaited<ReturnType<typeof agenciesControllerFindAllV1>>, TError = unknown>(
 params?: AgenciesControllerFindAllV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerFindAllV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgenciesControllerFindAllV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAgenciesControllerFindOneV1Url = (id: string,) => {




  return `/v1/agencies/${id}`
}

/**
 * @summary Get one agency
 */
export const agenciesControllerFindOneV1 = async (id: string, options?: RequestInit): Promise<AgencyViewDto> => {

  return apiRequest<AgencyViewDto>(getAgenciesControllerFindOneV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAgenciesControllerFindOneV1QueryKey = (id: string,) => {
    return [
    `/v1/agencies/${id}`
    ] as const;
    }


export const getAgenciesControllerFindOneV1QueryOptions = <TData = Awaited<ReturnType<typeof agenciesControllerFindOneV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerFindOneV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgenciesControllerFindOneV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof agenciesControllerFindOneV1>>> = ({ signal }) => agenciesControllerFindOneV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerFindOneV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgenciesControllerFindOneV1QueryResult = NonNullable<Awaited<ReturnType<typeof agenciesControllerFindOneV1>>>
export type AgenciesControllerFindOneV1QueryError = unknown


export function useAgenciesControllerFindOneV1<TData = Awaited<ReturnType<typeof agenciesControllerFindOneV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerFindOneV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerFindOneV1<TData = Awaited<ReturnType<typeof agenciesControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerFindOneV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerFindOneV1<TData = Awaited<ReturnType<typeof agenciesControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one agency
 */

export function useAgenciesControllerFindOneV1<TData = Awaited<ReturnType<typeof agenciesControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgenciesControllerFindOneV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAgenciesControllerUpdateV1Url = (id: string,) => {




  return `/v1/agencies/${id}`
}

/**
 * @summary Update agency data (name, description, logo, seats)
 */
export const agenciesControllerUpdateV1 = async (id: string,
    updateAgencyDto: UpdateAgencyDto, options?: RequestInit): Promise<AgencyViewDto> => {

  return apiRequest<AgencyViewDto>(getAgenciesControllerUpdateV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateAgencyDto)
  }
);}





export const getAgenciesControllerUpdateV1QueryKey = (id: string,
    updateAgencyDto?: UpdateAgencyDto,) => {
    return [
    'PATCH', `/v1/agencies/${id}`, updateAgencyDto
    ] as const;
    }


export const getAgenciesControllerUpdateV1QueryOptions = <TData = Awaited<ReturnType<typeof agenciesControllerUpdateV1>>, TError = unknown>(id: string,
    updateAgencyDto: UpdateAgencyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerUpdateV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgenciesControllerUpdateV1QueryKey(id,updateAgencyDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof agenciesControllerUpdateV1>>> = ({ signal }) => agenciesControllerUpdateV1(id,updateAgencyDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerUpdateV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgenciesControllerUpdateV1QueryResult = NonNullable<Awaited<ReturnType<typeof agenciesControllerUpdateV1>>>
export type AgenciesControllerUpdateV1QueryError = unknown


export function useAgenciesControllerUpdateV1<TData = Awaited<ReturnType<typeof agenciesControllerUpdateV1>>, TError = unknown>(
 id: string,
    updateAgencyDto: UpdateAgencyDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerUpdateV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerUpdateV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerUpdateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerUpdateV1<TData = Awaited<ReturnType<typeof agenciesControllerUpdateV1>>, TError = unknown>(
 id: string,
    updateAgencyDto: UpdateAgencyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerUpdateV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerUpdateV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerUpdateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerUpdateV1<TData = Awaited<ReturnType<typeof agenciesControllerUpdateV1>>, TError = unknown>(
 id: string,
    updateAgencyDto: UpdateAgencyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerUpdateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Update agency data (name, description, logo, seats)
 */

export function useAgenciesControllerUpdateV1<TData = Awaited<ReturnType<typeof agenciesControllerUpdateV1>>, TError = unknown>(
 id: string,
    updateAgencyDto: UpdateAgencyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerUpdateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgenciesControllerUpdateV1QueryOptions(id,updateAgencyDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAgenciesControllerResendRootInviteV1Url = (id: string,) => {




  return `/v1/agencies/${id}/resend-root-invite`
}

/**
 * @summary Re-issue and re-send the root activation email
 */
export const agenciesControllerResendRootInviteV1 = async (id: string, options?: RequestInit): Promise<ResendRootInviteResponseDto> => {

  return apiRequest<ResendRootInviteResponseDto>(getAgenciesControllerResendRootInviteV1Url(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAgenciesControllerResendRootInviteV1QueryKey = (id: string,) => {
    return [
    'POST', `/v1/agencies/${id}/resend-root-invite`
    ] as const;
    }


export const getAgenciesControllerResendRootInviteV1QueryOptions = <TData = Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgenciesControllerResendRootInviteV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>> = ({ signal }) => agenciesControllerResendRootInviteV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgenciesControllerResendRootInviteV1QueryResult = NonNullable<Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>>
export type AgenciesControllerResendRootInviteV1QueryError = unknown


export function useAgenciesControllerResendRootInviteV1<TData = Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerResendRootInviteV1<TData = Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerResendRootInviteV1<TData = Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Re-issue and re-send the root activation email
 */

export function useAgenciesControllerResendRootInviteV1<TData = Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerResendRootInviteV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgenciesControllerResendRootInviteV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAgenciesControllerAssignSubscriptionV1Url = (id: string,) => {




  return `/v1/agencies/${id}/subscription`
}

/**
 * @summary Assign or switch a comped tier (active at once, never charged)
 */
export const agenciesControllerAssignSubscriptionV1 = async (id: string,
    assignSubscriptionDto: AssignSubscriptionDto, options?: RequestInit): Promise<AgencyViewDto> => {

  return apiRequest<AgencyViewDto>(getAgenciesControllerAssignSubscriptionV1Url(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assignSubscriptionDto)
  }
);}





export const getAgenciesControllerAssignSubscriptionV1QueryKey = (id: string,
    assignSubscriptionDto?: AssignSubscriptionDto,) => {
    return [
    'PUT', `/v1/agencies/${id}/subscription`, assignSubscriptionDto
    ] as const;
    }


export const getAgenciesControllerAssignSubscriptionV1QueryOptions = <TData = Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>, TError = unknown>(id: string,
    assignSubscriptionDto: AssignSubscriptionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgenciesControllerAssignSubscriptionV1QueryKey(id,assignSubscriptionDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>> = ({ signal }) => agenciesControllerAssignSubscriptionV1(id,assignSubscriptionDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgenciesControllerAssignSubscriptionV1QueryResult = NonNullable<Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>>
export type AgenciesControllerAssignSubscriptionV1QueryError = unknown


export function useAgenciesControllerAssignSubscriptionV1<TData = Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>, TError = unknown>(
 id: string,
    assignSubscriptionDto: AssignSubscriptionDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerAssignSubscriptionV1<TData = Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>, TError = unknown>(
 id: string,
    assignSubscriptionDto: AssignSubscriptionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerAssignSubscriptionV1<TData = Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>, TError = unknown>(
 id: string,
    assignSubscriptionDto: AssignSubscriptionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Assign or switch a comped tier (active at once, never charged)
 */

export function useAgenciesControllerAssignSubscriptionV1<TData = Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>, TError = unknown>(
 id: string,
    assignSubscriptionDto: AssignSubscriptionDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerAssignSubscriptionV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgenciesControllerAssignSubscriptionV1QueryOptions(id,assignSubscriptionDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAgenciesControllerRemoveSubscriptionV1Url = (id: string,) => {




  return `/v1/agencies/${id}/subscription`
}

/**
 * @summary Remove the subscription: back to untiered
 */
export const agenciesControllerRemoveSubscriptionV1 = async (id: string, options?: RequestInit): Promise<AgencyViewDto> => {

  return apiRequest<AgencyViewDto>(getAgenciesControllerRemoveSubscriptionV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAgenciesControllerRemoveSubscriptionV1QueryKey = (id: string,) => {
    return [
    'DELETE', `/v1/agencies/${id}/subscription`
    ] as const;
    }


export const getAgenciesControllerRemoveSubscriptionV1QueryOptions = <TData = Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgenciesControllerRemoveSubscriptionV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>> = ({ signal }) => agenciesControllerRemoveSubscriptionV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgenciesControllerRemoveSubscriptionV1QueryResult = NonNullable<Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>>
export type AgenciesControllerRemoveSubscriptionV1QueryError = unknown


export function useAgenciesControllerRemoveSubscriptionV1<TData = Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerRemoveSubscriptionV1<TData = Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerRemoveSubscriptionV1<TData = Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Remove the subscription: back to untiered
 */

export function useAgenciesControllerRemoveSubscriptionV1<TData = Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerRemoveSubscriptionV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgenciesControllerRemoveSubscriptionV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






